/* Enord Core classic v1.0 — Market research table: phone swipe slider arrows. */
(function(){
  document.querySelectorAll('[data-ecr]').forEach(function(root){
    var cols=root.querySelector('[data-ecr-cols]'),pv=root.querySelector('[data-ecr-prev]'),nx=root.querySelector('[data-ecr-next]'),tm;
    if(!cols||!pv||!nx)return;
    var mq=window.matchMedia('(max-width:767.4999px)');
    function step(){var c=cols.children[1]||cols.children[0];return c?c.getBoundingClientRect().width:cols.clientWidth/2}
    function sync(){
      if(!mq.matches){pv.hidden=true;nx.hidden=true;return}
      var max=cols.scrollWidth-cols.clientWidth-2;
      pv.hidden=cols.scrollLeft<=2;nx.hidden=cols.scrollLeft>=max;
    }
    cols.addEventListener('scroll',function(){clearTimeout(tm);tm=setTimeout(sync,50)},{passive:true});
    pv.addEventListener('click',function(){cols.scrollBy({left:-step(),behavior:'smooth'})});
    nx.addEventListener('click',function(){cols.scrollBy({left:step(),behavior:'smooth'})});
    window.addEventListener('resize',sync);
    if(mq.addEventListener)mq.addEventListener('change',sync);
    sync();
  });
})();
